import {
  MotifButton,
  MotifButtonGroup,
  MotifChip,
  MotifDropdown,
  MotifDropdownItem,
  MotifDropdownPortal,
  MotifIcon,
} from "@ey-xd/motif-react";
import {
  IconoirNavArrowDown,
} from "@ey-xd/motif-icon";import { useTranslation } from "react-i18next";
// import { setShowBasicSeach } from "../../../claims/claimsSlice";
import { createSearchParams, useNavigate, useParams } from "react-router-dom";
import { SetStateAction, useCallback, useState } from "react";
import SearchInput from "@/components/SearchInput/SearchInput";
import { cleanPayload, commonFormateName, havingEditPermission } from "@/utility/common";
import ClaimBulkImport from "@/features/claims/claimsTab/components/ClaimBulkImport";
import { useLazyDownloadTemplateDocumentQuery } from "@/services/manualDataSource/ManualDataSourceReducer";
import { useSelector } from "react-redux";
import { IconoirMoreVert } from "@ey-xd/motif-icon";
import { CREATE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { useLazyExportDocumentQuery } from "@/services/exports/exportsReducer";

interface TitleComplementProps {
  caseId: string;
  debtorId: string;
  onSearch: (searchValue: string) => void;
  searchQuery: string;
  handleQuickSearchClear: () => void;
  isBasicSearch: boolean;
  handleClearBasicSearch: () => void;
  setIsBasicSearchApplied?: (value: boolean) => void;
  isBasicSearchApplied: boolean;
  isBasicSearchActive: boolean;
  setIsBasicSearchActive: (value: boolean) => void;
  setErrorMessage: (message: string) => void;
  debtorName?: string;
  paginationObj?:any;
  basicSearchPayload:any
}

export default function TitleComplement({
  onSearch,
  caseId,
  debtorId,
  handleQuickSearchClear,
  searchQuery,
  setIsBasicSearchApplied,
  isBasicSearchApplied,
  isBasicSearchActive,
  setIsBasicSearchActive,
  debtorName,
  setErrorMessage,
  paginationObj,
  basicSearchPayload,


}: TitleComplementProps) {
  const { t } = useTranslation();
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editId } = useParams();
  const [showMenu, setShowMenu] = useState(false);
  const [searchValue, setSearchValue] = useState(searchQuery);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [templateDownloadError, setTemplateDownloadError] = useState<string | undefined>("");
  const [downloadDocument] = useLazyDownloadTemplateDocumentQuery();
    const [exportDocument,{isFetching:exportLoading}] = useLazyExportDocumentQuery();
  
  const permissions = useSelector((state: any) => state.permissions);
  const debtorTitleMenu = [{
    label: t("pages.debtors.debtorClaimsSection.export"),
    value: "export"
  }];
    const { caseShortName,abbreviation } = useSelector((state: any) => state.case);
  
  const { Debtor, ImportJob ,Claim } = permissions;
  if (havingEditPermission(ImportJob) && havingEditPermission(Claim) ) {
    debtorTitleMenu.push({
      label: t("pages.debtors.debtorClaimsSection.bulkUpload"),
      value: "bulkUpload"
    })
  }


 

  const propData = {
    debtorId: editId || "",
  };

  const handleMenuClick = (value: string) => {
    const navigationPaths: { [key: string]: { path: string; state?: object } } =
    {
      addNewClaim: {
        path: `/case/${caseId}/claim/claim-setup?debtorId=${debtorId}`,
        state: propData,
      },
    };

    if (value === "bulkUpload") {
      setShowBulkUploadModal(true);
      return;
    }
    if(value === "export"){
      setErrorMessage("")
       exportDocument(
              
                !isBasicSearchApplied
                  ? 
                  {
                    url: "Debtor/ExportDebtorClaimsList",
                    ...paginationObj,
                    fileName: caseShortName?commonFormateName(caseShortName,"debtorclaims",abbreviation):"",
                  }
                  : {
                    url: "Debtor/ExportDebtorClaimsList",
                    ...{...cleanPayload(basicSearchPayload),...paginationObj},
                    fileName: caseShortName?commonFormateName(caseShortName,"debtorclaims",abbreviation):"",

      
                  },
        
                 ).then((response) => {
                  if (response?.error && 'data' in response.error) {
                    try {
                      const errObj = JSON.parse(response?.error?.data as string);
                      setErrorMessage(errObj?.message ||errObj.title);
                    } catch (error) {
                      setErrorMessage("Something went wrong!!");
                    }
                  }
                })
                .catch((error: any) => {
                  setErrorMessage("Something went wrong!!");
                })
                 return ;
    }

    const navigation = navigationPaths[value];
    if (navigation.state) {
      navigate(navigation.path, { state: navigation.state });
    } else {
      navigate(navigation.path);
    }
  };

  const handleDownloadBulkImportTemplate = async () => {
    try {
      await downloadDocument({
        entityType: "2",
      }).unwrap();
    } catch (error) {
      if (
        error &&
        typeof error === "object" &&
        "data" in error &&
        error?.data
      ) {
        const errObj = JSON.parse((error as any).data);
        return setTemplateDownloadError(errObj?.message || errObj?.title);
      } else setTemplateDownloadError("Something went wrong!!");
    }
  };

  const handleSearchChange = useCallback(
    (event: { target: { value: SetStateAction<string> } }) => {
      setSearchValue(event.target.value);
    },
    []
  );

  const handleOnSearch = useCallback(() => {
    onSearch(searchValue);
  }, [onSearch, searchValue]);

  if (!caseId) {
    return null;
  }

  return (
    <div className="motif-row align-items-center ">
        {!isBasicSearchActive && <SearchInput
          aria-label="Search"
          onChange={handleSearchChange}
          onClear={handleQuickSearchClear}
          onFocusShow={false}
          value={searchQuery}
          onEnter={handleOnSearch}
          placeholder={t("global.globalPlaceholder.quickSearchPlaceHolder")}
          withOutDebounce={true}
        />}
        {/* <MotifButtonGroup>
          <MotifButton
            variant="secondary"
            onClick={() => {
              dispatch(setShowBasicSeach(false));
            }}
          >
            {t("pages.claims.search.title")}
          </MotifButton>
          <MotifDropdownPortal
            open={showMenu}
            hideArrow={true}
            handleClickOutside={() => setShowMenu(false)}
            trigger={
              <MotifButton
                type="button"
                onClick={() => setShowMenu(!showMenu)}
                aria-label="Dropdown button"
                aria-haspopup="true"
                variant="secondary"
              >
                <MotifIcon
                  aria-label="Dropdown icon"
                  fill="none"
                  iconFunction={IconoirNavArrowDown}
                />
              </MotifButton>
            }
          >
            <MotifDropdownItem
              onClick={() => dispatch(setShowBasicSeach(true))}
            >
              {t("pages.claims.basicSearch.title")}
            </MotifDropdownItem>
            <MotifDropdownItem
              onClick={() => {
                dispatch(setShowBasicSeach(false));
              }}
            >
              {t("pages.claims.advancedSearch.title")}
            </MotifDropdownItem>
          </MotifDropdownPortal>
        </MotifButtonGroup> */}
         {!isBasicSearchActive &&<div style={{height:"49px",marginTop:"7px"}} className={!isBasicSearchApplied?"mar-r-20 debtor-claims-search-group":"debtor-claims-search-group"}><MotifButtonGroup  >
                  <MotifButton
                    variant="secondary"
                    onClick={() => {
                      // dispatch(setShowBasicSeach(false));
                    }}
                  >
              {t("global.globalPlaceholder.searchTypesDropdown")}
              </MotifButton>
                  <MotifDropdownPortal
                    open={showMenu}
                    hideArrow={true}
                    handleClickOutside={() => setShowMenu(false)}
                    trigger={
                      <MotifButton
                        type="button"
                        onClick={() => setShowMenu(!showMenu)}
                        aria-label="Dropdown button"
                        aria-haspopup="true"
                        variant="secondary"
                      >
                        <MotifIcon
                          aria-label="Dropdown icon"
                          fill="none"
                          iconFunction={IconoirNavArrowDown}
                        />
                      </MotifButton>
                    }
                  >
                    <MotifDropdownItem
                      onClick={() => {
                        // dispatch(setShowBasicSeach(true));
                        // setShowAdvanceSearch(false);
                        setIsBasicSearchActive(true);
                      }}
                    >
                      {t("pages.claims.basicSearch.title")}
                    </MotifDropdownItem>
                  
                  </MotifDropdownPortal>
                </MotifButtonGroup> </div>}
                {isBasicSearchApplied &&<MotifChip
                                      className="clear-search-chip"
                                      onClick={() => {
                                        handleQuickSearchClear()
                                      }}
                                      variant="monochrome-dark"
                                    >
                                      {t("pages.claims.basicSearch.clearSearch")}
                                    </MotifChip>}
                {havingEditPermission(Debtor) && <MotifButton style={{height:"44px"}}  variant={CREATE_BUTTON_VARIANT} onClick={()=>{
              navigate({
                pathname: `/case/${caseId}/claim/claim-setup`,
                search: createSearchParams({
                    debtorId: debtorId,
                    debtorName:debtorName?.replace(/ /g, "_") || ""
                }).toString()
            })
                }}>{t("pages.debtors.debtorClaimsSection.addNewClaim")}</MotifButton>}
        
        {debtorTitleMenu.length > 0 && <MotifDropdown
          ariaLabelledby="dropdown-trigger-1"
          id="dropdown-1"
          trigger={
            <MotifButton
              aria-label="dropdown button"
              id="dropdown-trigger-1"
              type="button"
              variant="text"
              loading={exportLoading}
            >
              <MotifIcon iconFunction={IconoirMoreVert} />
            </MotifButton>
          }
        >
          <ul role="menu">
            {debtorTitleMenu.map((menuName) => {
              return (
                <li role="menuitem">
                  <MotifDropdownItem
                    indexItem={1}
                    onClick={() => handleMenuClick(menuName.value)}
                  >
                    {menuName.label}
                  </MotifDropdownItem>
                </li>
              );
            })}
          </ul>
        </MotifDropdown>}
    
      

      {showBulkUploadModal && (
        <ClaimBulkImport
          showModal={true}
          setShowModal={setShowBulkUploadModal}
          title={t("pages.claims.claimsTable.bulkImport.title")}
          description={t("pages.claims.claimsTable.bulkImport.description")}
          onDownload={handleDownloadBulkImportTemplate}
          uploadLabel={t("pages.claims.claimsTable.bulkImport.uploadLabel")}
          uploadDescription={t(
            "pages.claims.claimsTable.bulkImport.uploadDescription"
          )}
          accept={t("pages.claims.claimsTable.bulkImport.accept")}
          maxFiles={1}
          onClose={() => {
            setShowBulkUploadModal(false);
          }}
          templateDownloadError={templateDownloadError}
        />
      )}
   </div>
  );
}
